import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useCreateMoodleConfig } from '../../queries/moodle/useCreateMoodleConfig';

const schema = z.object({
  baseUrl: z.string().url('Must be a valid URL').min(1, 'Base URL is required'),
  serviceName: z.string().min(1, 'Service name is required'),
  apiToken: z.string().min(1, 'API token is required'),
  isActive: z.boolean().default(true),
});

export const useCreateMoodleConfigForm = (onSuccess) => {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      baseUrl: '',
      serviceName: '',
      apiToken: '',
      isActive: true,
    },
  });

  const { mutate, isPending } = useCreateMoodleConfig(onSuccess);

  const onSubmit = form.handleSubmit((data) => mutate(data));

  return { form, onSubmit, isPending };
};
